module.exports = __webpack_public_path__ + "img/adult.890c65c0.svg";